import { PriceInfo } from '@model/product/PriceInfo';

export const getBasePrice = (priceInfo: PriceInfo, allQuantities: number, specialPrice: number) => {
  const { normalPrice } = priceInfo
  if (priceInfo.bundleType) {
    return allQuantities >= priceInfo.bundleQuantity ? priceInfo.topPrice : normalPrice;
  }
  return specialPrice || normalPrice;
};
